export const PAGE_TITLE = 'Ticketing Systems'

export enum CatalogTab {
  Directory,
  Instances
}

export const DIRECTORY_TAB_LABEL = 'Directory'

export const INSTANCES_TAB_LABEL = 'Instances'

export const NEW_SECTION_TITLE = 'New'

export const ALL_SECTION_TITLE = 'All Integrations'

export const NO_INSTANCES_TEXT = 'No Configured Instances'

export const ADD_INSTANCE_LABEL = 'Add Instance'

export const ABOUT_INTEGRATION_TITLE = 'About Integration'

export const CONFIGURED_BY_LABEL = 'Configured by'

export const DATE_CREATED_LABEL = 'Date created'

export const VIEW_ALL_LABEL = 'View all'

export const ABOUT_INSTANCE_TITLE = 'About Instance'

export const META_DATA_TITLE = 'Meta Data'

export const CREATED_BY_LABEL = 'Created by'

export const DATE_EDITED_LABEL = 'Date edited'

export const LATEST_EDIT_BY_LABEL = 'Latest edit by'

export const REMOVE_LABEL = 'Remove'

export const READ_ONLY_TOOLTIP = 'Read Only'

export const INSTANCE_DELETED_TITLE = 'Instance Deleted'

export const instanceDeletedDescription = (instanceName: string, integrationName: string) =>
  `Instance "${instanceName}" has been successfully removed from your ${integrationName} integration.`

export const REMOVE_FAILED_MESSAGE = 'The instance could not be removed. Please try again.'

export const LOAD_FAILED_MESSAGE = 'Ticketing systems could not be loaded'

export const SEARCH_PLACEHOLDER = 'Search'

export const PRODUCT_TYPE_LABEL = 'Product Type'

export const VENDOR_LABEL = 'Vendor'

export const PRODUCT_LABEL = 'Product'

export const CONFIGURATION_STATUS_LABEL = 'Configuration Status'

export const RESET_ALL_LABEL = 'Reset all'

export const ITEM_COUNT_LABEL = 'Number of items:'

export const EMPTY_TITLE = 'No Results Found'

export const NO_MATCH_DESCRIPTION =
  'Your filter did not match any issues, try adjusting the settings for better results'

export const NO_INTEGRATIONS_DESCRIPTION =
  'There are no integrations available at the moment. Start by creating a new integration to manage and monitor your environment efficiently.'

export const NO_INSTANCES_DESCRIPTION =
  'There are no instances available at the moment. Start by creating a new instance to manage and monitor your environment efficiently.'
